import { APP_CONTEXTS, IRootState } from "app/model"
import { CAMPAIGN_STATUSES } from "campaign/model"
import { FORM_SAVE_ERRORS, IAppForm, IFormError } from "form/model"
import React from "react"
import { connect } from "react-redux"
import { EditPage } from "./edit/EditPage"

interface IEditForecastPageProps {
  context: APP_CONTEXTS | null
  isLoadingInitialData: boolean
  hasInitialDataLoadingError: boolean
  isLoading: boolean
  error: IFormError
  saveError: FORM_SAVE_ERRORS | null
  status: CAMPAIGN_STATUSES | null
  appForm: IAppForm
}

const EditForecastPageFn = React.memo(
  ({
    context,
    isLoadingInitialData,
    hasInitialDataLoadingError,
    isLoading,
    error,
    saveError,
    status,
    appForm
  }: IEditForecastPageProps) => (
    <EditPage
      context={context}
      error={error}
      appForm={appForm}
      hasInitialDataLoadingError={hasInitialDataLoadingError}
      isLoading={isLoading}
      isLoadingInitialData={isLoadingInitialData}
      saveError={saveError}
      status={status}
      isForecast
      isDspDeal={false}
    />
  )
)

export const EditForecastPage = connect(
  (state: IRootState): IEditForecastPageProps => ({
    context: state.app.activeContext,
    isLoadingInitialData: state.app.isInitializating,
    hasInitialDataLoadingError: state.app.hasInitError,
    isLoading: state.form.forecastEditForm.isLoading,
    error: state.form.forecastEditForm.error,
    status: state.form.forecastEditForm.form.statusId,
    appForm: state.form.forecastEditForm,
    saveError: state.form.forecastEditForm.form.context.saveError
  })
)(EditForecastPageFn)
